import spritePool from '../spritePool'
import { Application, LoaderResource, Point, Sprite } from 'pixi.js'
import { Dict } from '@pixi/utils'
import getLevelOffsetBasedOnCurrentLevel from '../helpers/getLevelOffsetBasedOnCurrentLevel'

export let le_dragOffset = { x: 0, y: 0 }
export let le_dragTarget: any = null
export let le_isDragging = false

let le_menu: HTMLElement | null = null;

function onDragStart(event: any) {
	le_isDragging = true
	le_dragTarget = this
	this.alpha = 0.5
	const [leOffsetX, leOffsetY] = getLevelOffsetBasedOnCurrentLevel()

	le_dragOffset.x = event.data.global.x - event.currentTarget.x - leOffsetX
	le_dragOffset.y = event.data.global.y - event.currentTarget.y - leOffsetY
}

function onDragEnd() {
	le_isDragging = false
	if (le_dragTarget) {
		le_dragTarget.alpha = 1
		le_dragOffset.x = 0
		le_dragOffset.y = 0
		le_dragTarget = null
	}
}

function addDragHandling() {
	Object.values(spritePool.obstacleSprites).forEach(sprites =>
		sprites.forEach(sprite => {
			sprite.interactive = false
			sprite.on('mousedown', onDragStart, sprite)
		}),
	)
}

export const spawnSprite = (event: any) => {
	const key = event.target.innerHTML
	console.log('Spawning sprite: ', key)
	const resources = spritePool.obstacleSprites
	const sprite = new Sprite(resources[key][0].texture)
	sprite.anchor.set(0.5, 0.5)
	const [leOffsetX, leOffsetY] = getLevelOffsetBasedOnCurrentLevel()
	sprite.position = { x: 500, y: 500 }
	sprite.interactive = true
	spritePool.obstacleSprites[key].push(sprite)
	spritePool.container.addChild(sprite)
}

let isEditMode = false
document.body.addEventListener('mouseup', onDragEnd)
document.body.addEventListener('keydown', event => {
	if (event.key === 'i') {
		console.log(spritePool.obstacleSprites)
	}

	if (event.key === 'e') {
		isEditMode = !isEditMode
		toggleSpritesEditMode()
		console.log('Edit mode is: ' + (isEditMode ? 'ON' : 'OFF'))
		// Open menu
		le_menu?.classList.contains('d-none') ? le_menu?.classList.remove('d-none') : le_menu?.classList.add('d-none')
	}
})

const toggleSpritesEditMode = () => Object.values(spritePool.obstacleSprites).forEach(sprite => (sprite.interactive = isEditMode))

export const initLevelEditor = (resources: Dict<LoaderResource>) => {
	le_menu = document.getElementById('level-editor-menu')

	Object.keys(spritePool.obstacleSprites).forEach(key => {
		const sprite = new Sprite(resources[key].texture)
		sprite.anchor.set(0.5, 0.5)
		spritePool.obstacleSprites[key].push(sprite)
		spritePool.container.addChild(sprite)
	})
	addDragHandling()
}

export const levelEditorSystem = (app: Application) => {
	if (le_isDragging) {
		le_dragTarget.position.copyFrom(app.renderer.plugins.interaction.mouse.global)
	}
}
